module.exports = __webpack_public_path__ + "21c73dae6834647573f9082f144c56c6.png";